import styled from 'styled-components'
import { theme } from '../../styles/theme'

export const PageHeaderContainer = styled.div<{ $gradient?: string }>`
  background: linear-gradient(135deg, rgba(26, 26, 26, 0.8) 0%, rgba(42, 42, 42, 0.6) 100%);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 16px;
  padding: 2rem 2.5rem;
  margin-bottom: 2rem;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.4), 0 0 0 1px rgba(255, 255, 255, 0.1),
    0 0 30px rgba(102, 126, 234, 0.15);
  position: relative;
  display: flex;
  align-items: center;
  gap: 1rem;
  min-height: 5rem;
  backdrop-filter: blur(15px);
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(102, 126, 234, 0.8),
      rgba(118, 75, 162, 0.8),
      transparent
    );
    opacity: 0.8;
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      135deg,
      rgba(102, 126, 234, 0.05) 0%,
      rgba(118, 75, 162, 0.05) 100%
    );
    pointer-events: none;
  }

  .back-button {
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.2);
    color: white;
    padding: 0.5rem 0.75rem;
    border-radius: 6px;
    transition: all 0.2s;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.9rem;

    &:hover {
      background: rgba(255, 255, 255, 0.2);
      transform: translateY(-1px);
    }
  }

  .header-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
  }

  .page-title {
    font-size: 1.75rem;
    font-weight: 600;
    color: white;
    margin: 0;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
    display: flex;
    align-items: center;
    gap: 0.75rem;

    .title-icon {
      font-size: 1.5rem;
    }
  }

  .page-subtitle {
    color: rgba(255, 255, 255, 0.8);
    font-size: 0.95rem;
    margin: 0;
    line-height: 1.4;
  }

  .header-actions {
    display: flex;
    align-items: center;
    gap: 0.75rem;
  }
`

export const TabHeaderContainer = styled.div`
  background: rgba(42, 42, 42, 0.6);
  border: none;
  border-radius: 12px;
  margin: 0 0 1.5rem 0;
  padding: 0.5rem;
  backdrop-filter: blur(10px);
  position: relative;
  overflow: visible;

  .nav-tabs {
    background: transparent;
    border-bottom: none;
    margin: 0;
    gap: 0.75rem;
    font-size: 0.9rem;
    display: flex;

    .nav-item {
      margin: 0;
      display: flex;
      align-items: center;
    }

    .nav-link {
      border: 1px solid transparent;
      background: rgba(60, 60, 60, 0.3);
      color: #a0a0a0;
      border-radius: 10px;
      padding: 0.75rem 1rem;
      transition: all 0.3s ease;
      margin: 0;
      position: relative;
      overflow: hidden;
      font-weight: 500;
      backdrop-filter: blur(5px);
      display: flex;
      align-items: center;
      gap: 0.5rem;

      &:hover {
        background: rgba(74, 74, 74, 0.6);
        border-color: rgba(102, 126, 234, 0.3);
        color: #ffffff;
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      }

      &.active {
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        border-color: #667eea;
        color: #ffffff;
        font-weight: 600;
        transform: translateY(-2px);
        box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
        border-bottom: none;
      }

      &.disabled {
        opacity: 0.5;
        cursor: not-allowed;
        pointer-events: none;

        &:hover {
          transform: none;
        }
      }

      .tab-icon {
        font-size: 1.1rem;
      }
    }
  }
`

export const TabContentContainer = styled.div`
  background: transparent;
  min-height: 600px;
  padding: 2rem;
  border-radius: 0 0 16px 16px;
`

export const CompactPageHeader = styled.div<{ $gradient?: string }>`
  background: rgba(26, 26, 26, 0.4);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  padding: 1rem 1.5rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  gap: 0.75rem;
  min-height: 3rem;
  backdrop-filter: blur(5px);

  .page-title {
    font-size: 1.5rem;
    font-weight: 600;
    color: white;
    margin: 0;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
    display: flex;
    align-items: center;
    gap: 0.5rem;

    .title-icon {
      font-size: 1.25rem;
    }
  }

  .page-subtitle {
    color: rgba(255, 255, 255, 0.8);
    font-size: 0.9rem;
    margin: 0;
  }
`
